<h2 mat-dialog-title>{{ ("listDialog." + (!isEdit ? "addList" : "editList")) | translate }}</h2>
<div class="container" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
    <div class="form-container" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px">
        <mat-form-field>
            <mat-label>{{'listDialog.name' | translate}}</mat-label>
            <input matInput [formControl]="nameControl" maxlength="{{valueMaxLength}}" required>
            <mat-hint align="end">{{nameControl.value?.length || 0}}/{{ valueMaxLength }}</mat-hint>
            <mat-error *ngIf="nameControl.hasError('required')">
                {{'listDialog.valueRequired' | translate}}
            </mat-error>
            <mat-error *ngIf="nameControl.hasError('maxlength')">{{'listDialog.enterCharacters' | translate : {maxlength:maxlength} }}
            </mat-error>
        </mat-form-field>
        <mat-form-field>
            <mat-label>{{'listDialog.id' | translate}}</mat-label>
            <mat-select [placeholder]="'listDialog.id' | translate" [formControl]="idControl">
              <mat-option [value]="''">{{'listDialog.none' | translate}}</mat-option>
              <mat-option [value]="'VEList'">{{'listDialog.VEList' | translate}}</mat-option>
            </mat-select>
          </mat-form-field>
        <mat-form-field>
            <mat-label>{{'listDialog.enterList' | translate}}</mat-label>
            <mat-chip-grid #columnList>
                <mat-chip-row *ngFor="let name of observationList; index as i" (removed)="removeList(name)">
                    {{name}}
                    <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip-row>
                <input [matChipInputFor]="columnList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true"
                    (matChipInputTokenEnd)="add($event)">
            </mat-chip-grid>
            <mat-error *ngIf="listControl.hasError('required')">
                {{'listDialog.valueRequired' | translate}}
            </mat-error>
        </mat-form-field>
        <div fxLayout="row wrap" fxLayoutAlign="center">
            <mat-dialog-actions>
                <button mat-button mat-dialog-close color="primary">{{'listDialog.close' | translate}}</button>
                <button fxLayoutAlign="center" mat-raised-button color="primary" [disabled]="nameControl.invalid || observationList.length == 0" (click)="submit()">{{'listDialog.apply' | translate}}
                </button>
            </mat-dialog-actions>
        </div>
    </div>
</div>